import { OmitStrict } from "@supernova-studio/model";
import { serializeQuery } from "../../../../utils";
import { DTOElementsGetOutput, DTOElementsGetOutputV2, DTOElementsGetQueryParsed } from "../../../dto";
import { RequestExecutor } from "../../../transport/request-executor";

type GetElementsQuery = OmitStrict<DTOElementsGetQueryParsed, "responseVersion">;

export class ElementsEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  getElementsV1(dsId: string, vId: string, query: GetElementsQuery) {
    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${vId}/elements`, DTOElementsGetOutput, {
      query: serializeQuery(query),
    });
  }

  getElementsV2(dsId: string, vId: string, query: GetElementsQuery) {
    const fullQuery: DTOElementsGetQueryParsed = {
      ...query,
      responseVersion: 2,
    };

    return this.requestExecutor.json(`/design-systems/${dsId}/versions/${vId}/elements`, DTOElementsGetOutputV2, {
      query: serializeQuery(fullQuery),
    });
  }
}
